import { FC, useContext } from 'react'
import LocalizationContext from 'shared/contexts/LocalizationContext'
import PageContainer from 'shared/components/PageContainer'

type Props = {
  locale: string
}

const IdleTimeout: FC<Props> = ({ locale }) => {
  const { getString } = useContext(LocalizationContext)

  const subText = (
    <div className='landscape:mt-24 portrait:mt-16 flex flex-col portrait:px-12'>
      <p className='text-blackAlpha-500 text-sm text-center'>
        {getString('session_is_timed_out', locale)}
      </p>
    </div>
  )

  const handleSubmit = () => {
    window.location.reload()
  }

  return (
    <PageContainer>
      <div className='flex flex-col items-center justify-start min-h-screen bg-gray-50 pt-16 sm:p-24 px-4'>
        <form
          className='flex flex-col items-center bg-white rounded-xl shadow-sm p-6 sm:p-8 w-full max-w-sm gap-5'
          onSubmit={handleSubmit}
        >
          <div className='flex w-full h-full flex-col flex-1 items-center pb-16'>
            {subText}
          </div>

          <button
            type='submit'
            className={`w-full py-3 rounded-full bg-blue-600 text-white font-semibold shadow transition text-base 'hover:bg-blue-700 active:bg-blue-800`}
          >
            {getString('restart', locale)}
          </button>
        </form>
      </div>
    </PageContainer>
  )
}

export default IdleTimeout
